import React, { useMemo } from 'react'
import _ from 'lodash'
import InputField from '../../components/form/InputField'
import loadingGif from '../../assets/img/loading-pinwheel.gif'
import SelectOrCreate from '../../components/form/SelectOrCreate'
import { useForm, useField } from 'react-form'
import '../../assets/css/pages/class_management/transfer-students-form-popup.css'

function Field(props){
  const { meta: { error, isTouched, isValidating}, getInputProps } = useField(props.name)
  return <InputField {...props} input={getInputProps(props)} />
}

function SelectField(props) {
  const { meta: { error, isTouched, isValidating }, getInputProps } = useField(props.name)
  return <SelectOrCreate {...props} input={getInputProps(props)} />
}

const TransferStudentsFormPopup = props => {
  const { courseCollection, currentSectionId, students, rosters, defaultValues, handleSubmit, handleTransferExistingSection, handleVisitTargetSection, handleSuccessClose, transferSuccess, onClose, errors, isSubmitting } = props
  const { Form } = useForm({
    defaultValues: useMemo(()=>defaultValues,[]),
    onSubmit: (values)=>handleSubmit(values)
  })

  const sections = _.filter(_.reduce(rosters, (flattened, course) => flattened.concat(course.sections), []), section => section.id != currentSectionId)

  //if form submission results in an error, scroll to the top of the popup to ensure user sees error
  if (!_.isEmpty(errors)){
    const popup = document.getElementById('transfer-students-popup')
    if (!_.isEmpty(popup)) {popup.scrollTop = 0}
  }
  return(
    <div className=' popup-content new-course-popup popup dialog simple-popup tyto-popup dialog--open'>
      <div onClick={onClose} className='popup-background'></div>
      <div id='transfer-students-popup' className="transfer-students-form-popup dialog__content">
        <div className="container-fluid">
          <div className="dialog__overview">
            <h1>Transfer Students</h1>
            <p>Transfered Students will have their current progress saved, and they will recieve all associated class assignments of their new class.</p>
            <button onClick={transferSuccess ? handleSuccessClose : onClose} className="popup-close close action top-right" data-dialog-close=""><i className="fa fa-times"></i></button>
            {!_.isEmpty(errors) && <div className='error error-message'>{errors.join(',')}</div>}
            {!transferSuccess &&
              <div>
                <div className='transfer-existing-classes'>
                  {_.map(sections, section =>
                      <div className='section-row'>
                        <div className='transfer-column'>
                          <h4 className='section-name'>{section.name}</h4>
                          <p>{section.students.length + " students"}</p>
                        </div>
                        <div className='transfer-column'>
                          <button className='btn-primary transfer-button' onClick={()=>handleTransferExistingSection(section.id)}>Transfer to this Class</button>
                        </div>
                      </div>
                    )
                  }
                </div>
                <Form id='transfer-students-form'>
                  <h4>New Class</h4>
                  <SelectField
                    label='Course/Subject'
                    name='course'
                    placeholder='Type to create new or select existing'
                    selectProps={{
                      options:        courseCollection,
                      isClearable:    true
                    }}
                  />
                  <Field label='Class Name' name='name'/>
                  <Field label='Class Description' name='description'/>
                  <div className='transfer-new-button-row'>
                    <img className={`loading-gif ${(isSubmitting) ? '' : 'hidden'}`} src={loadingGif}/>
                    <button className='btn-primary transfer-button' type='submit'>Transfer to this Class</button>
                  </div>
                </Form>
              </div>
            }
            {transferSuccess &&
              <div className='transfer-success'>
                <div className='success-message'>Success!</div>
                <br/>
                <div className='transfer-success-button-row'>
                  <button className='btn-primary transfer-button' onClick={handleVisitTargetSection}>Go to Tranferred-to Class</button>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransferStudentsFormPopup;
